// extracted by mini-css-extract-plugin
export default {"root":"ClearFilters_root__tcLt6","icon":"ClearFilters_icon__FRKMl","text":"ClearFilters_text__LKlID"};